module.exports = __webpack_public_path__ + "media/images/payment/visa-51644d1eefe6bf0c3d649cd50a042359.svg";